import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["itemsContainer", "itemTemplate", "item"]

  addItem(event) {
    event.preventDefault()

    const content = this.itemTemplateTarget.innerHTML
    const newId = new Date().getTime()
    const newContent = content.replace(/NEW_RECORD/g, newId)

    this.itemsContainerTarget.insertAdjacentHTML('beforeend', newContent)
  }

  removeItem(event) {
    event.preventDefault()

    const item = event.target.closest('[data-stock-transfer-target="item"]')

    if (item.dataset.newRecord === "true") {
      // If it's a new record, just remove the element
      item.remove()
    } else {
      // If it's a persisted record, mark for destruction
      const destroyField = item.querySelector('input[name*="_destroy"]')
      if (destroyField) {
        destroyField.value = "1"
      }
      item.style.display = 'none'
    }
  }

  updateFromLocations(event) {
    const warehouseId = event.target.value
    this.updateLocationDropdown('from', warehouseId)
  }

  updateToLocations(event) {
    const warehouseId = event.target.value
    this.updateLocationDropdown('to', warehouseId)
  }

  async updateLocationDropdown(direction, warehouseId) {
    if (!warehouseId) return

    try {
      const response = await fetch(`/wms/warehouses/${warehouseId}/locations.json`)
      const locations = await response.json()

      const selectElement = direction === 'from'
        ? document.querySelector('[name="transfer[from_location_id]"]')
        : document.querySelector('[name="transfer[to_location_id]"]')

      if (selectElement) {
        // Clear existing options except the blank one
        selectElement.innerHTML = '<option value="">Any location in warehouse</option>'

        // Add new options
        locations.forEach(location => {
          const option = document.createElement('option')
          option.value = location.id
          option.textContent = `${location.code} - ${location.name}`
          selectElement.appendChild(option)
        })

        selectElement.disabled = false
      }
    } catch (error) {
      console.error('Error fetching locations:', error)
    }
  }
}
